export const RESOLUTION_TYPES = {
	deadhead: 'deadhead',
	parallelRide: 'parallelRide',
	replacementCrewMember: 'replacementCrewMember',
};

export const CUSHION_CHOICES = {
	originalDriver: 'originalDriver',
	deadheadDriver: 'deadheadDriver',
};

export const CUSHION_CHOICE_LABELS = {
	[CUSHION_CHOICES.originalDriver]: 'Original driver',
	[CUSHION_CHOICES.deadheadDriver]: 'Deadhead driver',
};

export const NODE_IDS = {
	common: 'common',
	parallelRide: 'parallelRide',
	parallelRideWithCushion: 'parallelRideWithCushion',
	busDeadhead: 'busDeadhead',
	fatigueReplacement: 'fatigueReplacement',
	driverOutOfHoursReplacement: 'driverOutOfHoursReplacement',
	summary: 'summary',
};

export const DEFAULT_ABSENCE_REASON_NAME = 'Fatigue Book Off';

export const SECTION_IDS = {
	common: 'common',
	deadheadInfo: 'deadheadInfo',
	replacementDriverInfo: 'replacementDriverInfo',
	postIncidentDriving: 'postIncidentDriving',
	cushioningParameters: 'cushioningParameters',
	parallelRide: 'parallelRide',
};
